import Seo from "@/components/site/Seo";
import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";

const beliefs = [
  { n: "01", t: "Every brand is a digital experience.", d: "Identity, ads, product, web — all one experience now. We design it deliberately." },
  { n: "02", t: "Senior craft, every touchpoint.", d: "No juniors on client brands. No rotating strangers. One team stays with you all year." },
  { n: "03", t: "Membership is our model, not the point.", d: "The point is the work. The membership just makes the work deeper, faster and more compounding." },
  { n: "04", t: "The room is what protects the work.", d: "A curated group of fast-scaling, non-competing brands raises the standard for everyone in it." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo title="About | Midcreatives" description="Midcreatives is a global creative design company — Dubai and Toronto — helping ambitious brands build world-class brand and digital experiences." path="/about" />
      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pt-10 md:pt-16 pb-16 md:pb-24 relative">
        <div className="glow-blue" />
        <p className="font-mono-mc mb-6 relative">About · The company</p>
        <h1 className="font-display-tight text-5xl sm:text-7xl lg:text-[112px] ink leading-[0.92] max-w-6xl relative">
          We're a global creative design company. <span className="ink-muted">Membership is how we work with you.</span>
        </h1>
      </section>

      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pb-24 md:pb-32">
        <div className="rounded-[32px] border border-white/10 bg-[color:var(--surface)] p-8 md:p-16 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-mono-mc mb-4">Manifesto</p>
          </div>
          <div className="md:col-span-7 space-y-8">
            <p className="font-display-tight text-3xl md:text-5xl ink leading-tight">
              We design brands people remember <span className="ink-muted">— and the digital experiences that keep them coming back.</span>
            </p>
            <p className="ink-muted text-base md:text-lg leading-relaxed">
              Every brand is becoming a digital experience. The identity people recognize, the ads
              they scroll past or stop for, the product they touch — it's all one experience now.
            </p>
            <p className="ink-muted text-base md:text-lg leading-relaxed">
              We exist to help ambitious brands design that experience deliberately. Brand
              identity, campaigns, product and web — held under one senior team, working with you
              every business day of the year.
            </p>
            <p className="font-display-tight text-3xl md:text-5xl ink leading-tight">
              Membership is simply <span className="text-lime">how we work.</span>
            </p>
            <p className="ink-muted text-base md:text-lg leading-relaxed">
              One annual commitment. A dedicated senior team. A budget held for your big moves. A
              curated network of peers scaling at the same speed. Access to the design leaders who
              set the standard. It's not a subscription. It's a room.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-4">
            <p className="font-mono-mc mb-4">What we believe</p>
            <h2 className="font-display-tight text-4xl md:text-5xl ink leading-[1.0]">
              Four <span className="text-lime">principles.</span>
            </h2>
          </div>
          <div className="md:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4">
            {beliefs.map((b, i) => (
              <Reveal key={b.n} delay={i * 0.05}>
                <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 md:p-8 h-full">
                  <p className="font-mono-mc">{b.n}</p>
                  <h4 className="font-display-tight text-2xl md:text-3xl ink mt-6">{b.t}</h4>
                  <p className="ink-muted mt-3 leading-relaxed">{b.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pb-24 md:pb-32">
        <div className="rounded-[32px] border border-white/10 bg-[color:var(--surface)] p-10 md:p-16 grid grid-cols-1 md:grid-cols-12 gap-10 items-end relative overflow-hidden">
          <div className="glow-lime" />
          <div className="md:col-span-8 relative">
            <h2 className="font-display-tight text-4xl md:text-6xl ink leading-[1.0]">
              Design your next decade <span className="text-lime">deliberately.</span>
            </h2>
          </div>
          <div className="md:col-span-4 md:text-right relative">
            <Link to="/apply" data-testid="about-apply-cta" className="btn-lime">
              Get Membership <span className="arrow-slide">→</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
